'use client'

import { useRef, useState, useEffect } from 'react'
import { 
  QueryClient, 
  QueryClientProvider, 
  HydrationBoundary 
} from '@tanstack/react-query'

interface Props {
  children: React.ReactNode
  dehydratedState?: unknown
}

export const ReactQueryClientProvider = ({ 
  children, 
  dehydratedState 
}: Props) => {
  const [mounted, setMounted] = useState(false);
  const queryClientRef = useRef<QueryClient>()
  
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  
  if (!queryClientRef.current) {
    queryClientRef.current = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 60 * 5000
        }
      }
    })
  }

  // Wait until mounted to render with client-side data
  if (!mounted) {
    return null;
  }

  return (
    <QueryClientProvider client={queryClientRef.current}>
      <HydrationBoundary state={dehydratedState}>
        {children}
      </HydrationBoundary>
    </QueryClientProvider>
  )
}